var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.obj_to_null(_vm.vacation)
    ? _c(
        "div",
        { staticClass: "vacation_info" },
        [
          _c("b-badge", { attrs: { variant: "warning" } }, [
            _vm._v(
              "Відпустка на період " +
                _vm._s(_vm.vacation.d_from) +
                " - " +
                _vm._s(_vm.vacation.d_to)
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }